import { Cart, cart_params } from "./../models/cart_model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
import { Subject, Observable } from "rxjs";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { ManageNewsLettersService } from "src/app/views/common/services/manage-news-letters.service";
import { DomSanitizer } from "@angular/platform-browser";

interface BroadcastEvent {
  key: any;
  data?: any;
}
@Injectable()
export class CommonService {
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }
  myHeaders = this.setHeader();
  private isLoading = new Subject<boolean>();
  // private panoramaCategory = new Subject<boolean>();
  private isWebLoading = new Subject<boolean>();
  private rowData = new Subject<BroadcastEvent>();
  public updateProgress = new Subject<any>();
  public sendSecureData = new Subject<any>();

  isLoadingStream$ = this.isLoading.asObservable();
  // panoramaCategory$ = this.panoramaCategory.asObservable();
  isWebLoadingStream$ = this.isWebLoading.asObservable();
  rowDataStream$ = this.rowData.asObservable();
  updateProgress$ = this.updateProgress.asObservable();
  sendSecureData$ = this.sendSecureData.asObservable();

  refreshEvent: any;
  panoramaCategory: any;
  getCategoriesByShoreType: any;
  setDynamicBreadCrumb: any;
  setPriceToDefault: any;
  refreshManagerSiteChange: any;



  constructor(
    private router: Router,
    private http: HttpClient,
    private newslettersrv: ManageNewsLettersService,
    public _DomSanitizationService: DomSanitizer
  ) {
    this.refreshEvent = new EventEmitter<any>();
    this.panoramaCategory = new EventEmitter<any>();
    this.getCategoriesByShoreType = new EventEmitter<any>();
    this.setDynamicBreadCrumb = new EventEmitter<any>();
    this.setPriceToDefault = new EventEmitter<Boolean>();
    this.refreshManagerSiteChange = new EventEmitter<Boolean>();
    // this.updateProgress = new EventEmitter<any>();
  }


  changeManagerSite() {
    this.refreshManagerSiteChange.emit(true);
  }

  setToDefaultPrice() {
    this.setPriceToDefault.emit(true);
  }

  setSecureData(secureData) {
    this.sendSecureData.next(secureData);
  }

  setBreadCrumb(value) {
    this.setDynamicBreadCrumb.emit(value);
  }
  setProgress(progressValue) {
    this.updateProgress.next(progressValue);
  }
  refreshComponent(action) {
    this.refreshEvent.emit(action);
  }
  getCategoriesByStore(action) {
    this.getCategoriesByShoreType.emit(action);
  }
  setRowData(key: any, data?: any) {
    this.rowData.next({ key, data });
  }

  onRowData<T>(key: any): Observable<T> {
    return this.rowData
      .asObservable()
      .filter((event) => event.key === key)
      .map((event) => <T>event.data);
  }

  showLoader(value) {
    this.isLoading.next(value);
  }

  hideLoader(value) {
    this.isLoading.next(value);
  }

  showWebLoader() {
    this.isWebLoading.next(true);
  }

  hideWebLoader() {
    this.isWebLoading.next(false);
  }

  showPanoramic(value) {
    this.panoramaCategory.emit(value);
  }

  hidePanoramic(value) {
    this.panoramaCategory.emit(value);
  }

  navigateToBlock(blockName) {
    this.router.navigateByUrl("/WebPanel");
    setTimeout(() => {
      document.getElementById(blockName).scrollIntoView({ behavior: "smooth" });
    }, 1);
  }

  getCodeList(moduleName) {
    let url = environment.URL + "/code/" + moduleName;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getOrderBreakDown(orderDetails, VAT) {
    let vatFraction: any = parseFloat(VAT) / 100 + 1;
    let priceLessVAT: any =
      parseFloat(orderDetails.total_amount) / parseFloat(vatFraction);
    let VATPrice: any =
      parseFloat(orderDetails.total_amount) - parseFloat(priceLessVAT);
    // (parseFloat(orderDetails.total_amount) * parseFloat(VAT)) / 100

    orderDetails.vatLessPrice = this.toFixed(priceLessVAT, 2);
    orderDetails.vatPrice = this.toFixed(VATPrice, 2);

    let vatData = {
      vatPrice: orderDetails.vatPrice,
      vatLessPrice: orderDetails.vatLessPrice,
    };

    console.log("VAT Data : ", vatData);
    return vatData;
  }

  getCheckoutOrderBreakDown(cartOrder, VAT) {
    let vatFraction: any = parseFloat(VAT) / 100 + 1;
    let totalOrderAmount = 0;
    for (var i in cartOrder) {
      totalOrderAmount =
        totalOrderAmount +
        parseFloat(cartOrder[i].price) * parseFloat(cartOrder[i].quantity);
    }

    totalOrderAmount = this.toFixed(totalOrderAmount, 2);
    // console.log("totalOrderAmount : ", totalOrderAmount)
    let priceLessVAT: any = totalOrderAmount / parseFloat(vatFraction);
    let VATPrice: any = totalOrderAmount - priceLessVAT;
    // (totalOrderAmount * parseFloat(VAT)) / 100
    // let priceLessVAT: any = totalOrderAmount - parseFloat(VATPrice)
    cartOrder.vatPrice = this.toFixed(VATPrice, 2);
    cartOrder.vatLessPrice = this.toFixed(priceLessVAT, 2);

    let vatData = {
      vatPrice: cartOrder.vatPrice,
      vatLessPrice: cartOrder.vatLessPrice,
    };

    console.log("VAT Data : ", vatData);
    return vatData;
  }

  toFixed(num, precision) {
    // return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    //   precision
    // );
    return this.number_format(num, precision, undefined, undefined);
  }

  number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s: any = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }
  getImageURL(imageURL) {
    return this._DomSanitizationService.bypassSecurityTrustUrl(
      environment.imageURL + imageURL
    );
  }
  getImageStyleURL(imageURL) {
    return environment.imageURL + imageURL;
  }

  getUSBImageURL() {
    return environment.USBImage;
  }

  countToArray(i: number) {
    return new Array(i);
  }

  getFormattedTime(event) {

    let timeSplit = event.target.value.split(':');
    let hours = timeSplit[0];
    let minutes = timeSplit[1];
    let meridian;

    if (hours > 12) {
      meridian = 'PM';
      hours -= 12;
    } else if (hours < 12) {
      meridian = 'AM';
      if (hours == 0) {
        hours = 12;
      }
    } else {
      meridian = 'PM';
    }
    return hours + ':' + minutes + ' ' + meridian
  }

  addDays(date: Date, days: number): Date {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }
}
